var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.38672C16.7175 6.38673 16.9276 6.46549 17.0915 6.60844C17.2554 6.75139 17.362 6.94885 17.3916 7.16432L17.4 7.28672V18.0867C17.3999 18.3147 17.3133 18.5342 17.1576 18.7009C17.0019 18.8675 16.7888 18.9688 16.5613 18.9843C16.3338 18.9999 16.1089 18.9285 15.932 18.7846C15.7551 18.6407 15.6395 18.435 15.6084 18.2091L15.6 18.0867V7.28672C15.6 7.04802 15.6948 6.81911 15.8636 6.65032C16.0324 6.48154 16.2613 6.38672 16.5 6.38672ZM6.56399 6.65072C6.71637 6.4983 6.9184 6.40562 7.13333 6.38955C7.34826 6.37347 7.56183 6.43506 7.73519 6.56312L7.83599 6.65072L13.236 12.0507C13.3884 12.2031 13.4811 12.4051 13.4972 12.6201C13.5132 12.835 13.4516 13.0486 13.3236 13.2219L13.236 13.3227L7.83599 18.7227C7.67519 18.8823 7.46014 18.9753 7.23376 18.9833C7.00737 18.9913 6.78631 18.9136 6.61469 18.7657C6.44306 18.6179 6.3335 18.4108 6.30786 18.1857C6.28223 17.9606 6.34241 17.7342 6.47639 17.5515L6.56399 17.4507L11.328 12.6867L6.56399 7.92272C6.39545 7.75397 6.30078 7.52522 6.30078 7.28672C6.30078 7.04822 6.39545 6.81947 6.56399 6.65072Z",
    fill: "#7C63A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootNext);
export default __webpack_public_path__ + "static/media/foot-next.a1c8e02892fe960f90c92fe120c23283.svg";
export { ForwardRef as ReactComponent };